import { createSlice } from '@reduxjs/toolkit';

export const idSlice = createSlice({
    name: "id",
    initialState: {
        homeView: 'home'
    },
    reducers: {
        homeViewChange: (state, action) => {
            return {
                ...state,
                homeView: action.payload
            }
        }
    }
})

export const { homeViewChange } = idSlice.actions

export default idSlice.reducer